import {atom} from 'recoil';

export const durationState = atom({
    key: 'durationState',
    default: 0
});

export const timeOutState = atom({
    key: 'timeOutState',
    default: false
});

export const timeOutV2State = atom({
    key: 'timeOutV2State',
    default: false
});

export const errorCodeState = atom({
    key: 'errorCodeState',
    default: ""
});

const TEST_STARTER_STATUS = "starterStatus";
const TEST_IN_PROGRESS_STATUS = "inProgressStatus";

export const testStatusState = atom({
    key: 'testStatusState',
    default: {"current_status": TEST_STARTER_STATUS}
});

export const isZoomingImage = atom({
    key: 'isZoomingImage',
    default: false
});

export const requiredTimeState = atom({
    key: 'requiredTimeState',
    default: 0
});

export const requiredTimeSubmitState = atom({
    key: 'requiredTimeSubmitState',
    default: true
});

export const valueSlideState = atom({
    key: 'valueSlideState',
    default: 1
});

export const isOnlineState = atom({
    key: 'isOnlineState',
    default: window.navigator.onLine
});

export const isTouchVideoState = atom({
    key: 'isTouchVideoState',
    default: false
});

export const isTouchAudioState = atom({
    key: 'isTouchAudioState',
    default: false
});

export const tokenInfoState = atom({
    key: 'tokenInfoState',
    default: {}
});
